module.exports = __webpack_public_path__ + "static/media/info-icon-green.01a08b56.svg";